import React, { useEffect } from "react";
import UserActions from "../../store/user/Actions";
import { connect } from "react-redux";

function ToastBox(props) {
  const { showToastModal, toastMessageText, toastType } = props; // from redux state
  const { showOrHideToaster } = props; //from dispatch

  useEffect(() => {
    if (showToastModal) {
      setTimeout(() => {
        showOrHideToaster(false, undefined, undefined);
      }, 2000);
    }
  }, [showToastModal]);

  return (
    <span>
      {showToastModal ? (
        <div
          style={{
            width: "100%",
            top: "12%",
            margin: "auto",
            position: "absolute",
            zIndex: 99,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <span
            style={{
              width: "50%",
              margin: "auto",
              textAlign: "center",
              backgroundColor:
                toastType === "success"
                  ? "#3EC986"
                  : toastType === "warning"
                  ? "#ffc42d"
                  : "#FF551F",
              zIndex: 99,
              borderRadius: "10px",
            }}
          >
            <p
              style={{
                color: toastType === "warning" ? "#000000" : "#ffffff",
                padding: "1%",
                margin: 0,
              }}
            >
              {toastMessageText && toastMessageText}
            </p>
          </span>
        </div>
      ) : undefined}
    </span>
  );
}

const mapStateToProps = (state) => ({
  showToastModal: state.user.showToastModal,
  toastMessageText: state.user.toastMessageText,
  toastType: state.user.toastType,
});

const mapDispatchToProps = (dispatch) => ({
  showOrHideToaster: (showToastModal, toastMessageText, toastType) =>
    dispatch(
      UserActions.showOrHideToaster(showToastModal, toastMessageText, toastType)
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ToastBox);
